var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaseStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15838_94720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 2.25,
    width: 35.5,
    height: 35.5,
    rx: 5.75,
    stroke: "#CED4DA",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7513 13.0827C13.3831 13.0827 13.0846 13.3812 13.0846 13.7493V26.2493C13.0846 26.6175 13.3831 26.916 13.7513 26.916H14.418V21.2493C14.418 20.2368 15.2388 19.416 16.2513 19.416H23.7513C24.7638 19.416 25.5846 20.2368 25.5846 21.2493V26.916H26.2513C26.6195 26.916 26.918 26.6175 26.918 26.2493V16.7671C26.918 16.5903 26.8477 16.4207 26.7227 16.2957L23.7049 13.2779C23.5799 13.1529 23.4103 13.0827 23.2335 13.0827H23.0846V14.9993C23.0846 16.0119 22.2638 16.8327 21.2513 16.8327H17.5013C16.4888 16.8327 15.668 16.0119 15.668 14.9993V13.0827H13.7513ZM16.8346 13.0827V14.9993C16.8346 15.3675 17.1331 15.666 17.5013 15.666H21.2513C21.6195 15.666 21.918 15.3675 21.918 14.9993V13.0827H16.8346ZM24.418 26.916V21.2493C24.418 20.8812 24.1195 20.5827 23.7513 20.5827H16.2513C15.8831 20.5827 15.5846 20.8812 15.5846 21.2493V26.916H24.418ZM11.918 13.7493C11.918 12.7368 12.7388 11.916 13.7513 11.916H23.2335C23.7198 11.916 24.1861 12.1092 24.5299 12.453L27.5477 15.4708C27.8915 15.8146 28.0846 16.2809 28.0846 16.7671V26.2493C28.0846 27.2619 27.2638 28.0827 26.2513 28.0827H13.7513C12.7388 28.0827 11.918 27.2619 11.918 26.2493V13.7493Z",
    fill: "#324854"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15838_94720",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15838_94720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15838_94720",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseStep);
export default __webpack_public_path__ + "static/media/base-step.42e66a964e8096f87abfeae68dec93b5.svg";
export { ForwardRef as ReactComponent };